const pdfMake = require('pdfmake/build/pdfmake.js');
const pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { formatData } from '@/constants/commonContent';

export default function certificatePdfMaker (
  { totalSupply, profileName, date, companyName, tokenBalance },
  getMember,
  owners
) {
  const title = 'Shares certificate';
  const p =
    profileName +
    ' owns ' +
    formatData.number(tokenBalance) +
    ' shares out of total supply ' +
    totalSupply +
    ' of ' +
    companyName +
    ' company on ' +
    date;
  const rowTop: any[] = [];
  const signRow: any[] = [
    {},
    { text: '\nShareholder: ' + profileName, alignment: 'right' },
    { text: '\n', alignment: 'right' },
    { text: '\nSignature: ' + profileName, alignment: 'right', italics: true }
  ];
  rowTop.push(signRow);

  function memberSign (name) {
    return { text: 'Signature: ' + name, alignment: 'right', italics: true };
  }
  const signRow2: any[] = [];
  for (let addr in owners) {
    const footerRow: any[] = [];
    signRow2.push([{ text: '\n' }, { text: '\n' }, { text: '\n' }, { text: '\n' }]);
    footerRow.push({});
    footerRow.push({ text: 'Director: ' + getMember(addr).name, alignment: 'right' });
    footerRow.push({ text: '', alignment: 'right' });
    footerRow.push(memberSign(getMember(addr).name));
    signRow2.push(footerRow);
  }
  const dd = {
    content: [
      {
        text: title,
        style: 'header',
        margin: [150, 0, 0, 20],
        fontSize: 22
      },
      {
        text: p,
        style: 'header',
        bold: false,
        margin: [0, 50, 0, 100]
      },
      {
        table: {
          widths: ['*', 'auto', '20%', 'auto'],
          body: rowTop,
          headerRows: 0
        },
        layout: 'noBorders',
        style: 'header',
        bold: false
      },
      {
        table: {
          widths: ['*', 'auto', '20%', 'auto'],
          body: signRow2,
          headerRows: 0
        },
        layout: 'noBorders',
        style: 'header',
        bold: false,
        margin: [0, 50, 0, 0]
      }
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        alignment: 'justify'
      }
    }
  };
  return pdfMake.createPdf(dd);
}
